
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatCNPJ',
    standalone: false
})
export class FormatCNPJPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    if (value == null || value == "")
      return value

    return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, '$1.$2.$3/$4-$5');
  }

}